import { z } from 'zod';

export const sendSubscriptionFormPostRequestSchema = z.object({});
